class i extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector(".quantity__input")),
      (this.minus = this.querySelector('.quantity__button[name="minus"]')),
      (this.plus = this.querySelector('.quantity__button[name="plus"]')),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.minus.addEventListener("click", (t) => {
        this.decreaseQuantity();
      }),
      this.plus.addEventListener("click", (t) => {
        this.increaseQuantity();
      });
  }
  decreaseQuantity(t) {
    const e = this.input.value;
    Number(this.input.value) != 1 &&
      ((this.input.value = Number(this.input.value) - 1),
      e !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
  increaseQuantity(t) {
    // console.log("increase start.");
    const e = this.input.value;
    const next_e = Number(this.input.value) + 1;
    const stock = this.input.getAttribute("data-stock");
    const cart_count = this.input.getAttribute("data-cart-count");
    // console.log("next_e: "+ next_e + ", e:" + e + ", stock:" + (stock - cart_count));
    if (next_e > (stock - cart_count)) {
      // console.log("next_e > stock: " + (next_e > (stock - cart_count)));
      return;
    }
    // console.log("increase increment.");
    (this.input.value = Number(this.input.value) + 1),
      e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    // console.log("increase end.");
  }
}
customElements.define("quantity-select", i);
